import './Overlay.css';
export var overlayCSS = '_1dhu6810-3-5-0';